import CoreUtils from '../../../utils/coreUtils.js';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';
import GeoUtils from 'shared/libraries/mwc/3d/nodeGraph/geoUtils';

export default class NodeMorph extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.FLOAT, 'interpolation', 50, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo1', null);
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo2', null);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'morph';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList1 = inputValues['geo1'];
		let pGeoList2 = inputValues['geo2'];
		if(!pGeoList1 || !pGeoList2)
			return null;

		pGeoList1 = pGeoList1.filter(m => !!m);
		pGeoList2 = pGeoList2.filter(m => !!m);
		if(pGeoList1.length === 0 || pGeoList2.length === 0)
			return;

		let mesh1 = pGeoList1[0];
		let mesh2 = pGeoList2[0];

		let interp = inputValues['interpolation']/100.0;

		let sourcePositions = mesh1.getVerticesData(BABYLON.VertexBuffer.PositionKind);
		let targetPositions = mesh2.getVerticesData(BABYLON.VertexBuffer.PositionKind);

		if(targetPositions.length < sourcePositions.length)
		{
			mesh1 = pGeoList2[0];
			mesh2 = pGeoList1[0];

			sourcePositions = mesh1.getVerticesData(BABYLON.VertexBuffer.PositionKind);
			targetPositions = mesh2.getVerticesData(BABYLON.VertexBuffer.PositionKind);
		}

		let sourceNormals = mesh1.getVerticesData(BABYLON.VertexBuffer.NormalKind);
		let targetNormals = mesh2.getVerticesData(BABYLON.VertexBuffer.NormalKind);

		let sourceUVs = mesh1.getVerticesData(BABYLON.VertexBuffer.UVKind);
		let targetUVs = mesh2.getVerticesData(BABYLON.VertexBuffer.UVKind);

		if(mesh1.parentNodeId)
		{
			// If the source is another file node, we need to clear the asset attributes
			let pSourceNode = this.getGraph().getNode(mesh1.parentNodeId);
			if(pSourceNode && pSourceNode.getType() === 'file')
				mesh1 = Utils3D.clearAssetAttributes(mesh1, this.getId());
		}

		mesh1.makeGeometryUnique();
		mesh1.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, true);
		mesh1.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.NormalKind, true);

		let newPositions = [];
		for(let index = 0; index < sourcePositions.length; index++)
			newPositions[index] = CoreUtils.interpolate(interp, sourcePositions[index], targetPositions[index]);

		let newNormals = [];
		for(let index = 0; index < sourceNormals.length; index++)
			newNormals[index] = CoreUtils.interpolate(interp, sourceNormals[index], targetNormals[index]);

		let newUVs = [];
		if(sourceUVs && targetUVs)
		{
			mesh1.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.UVKind, true);
			for(let index = 0; index < sourceUVs.length; index++)
				newUVs[index] = CoreUtils.interpolate(interp, sourceUVs[index], targetUVs[index]);
			mesh1.setVerticesData(BABYLON.VertexBuffer.UVKind, newUVs, true);
		}

		mesh1.setVerticesData(BABYLON.VertexBuffer.PositionKind, newPositions, true);
		mesh1.setVerticesData(BABYLON.VertexBuffer.NormalKind, newNormals, true);

		/*
		// This is the old way we used to do it - however, it appears to be flipping normals on some assets,
		// so now we interpolate the normals manually above.
		mesh1.updateMeshPositions((srcPositions) => {
			for(let idx = 0; idx < srcPositions.length; idx += 3)
			{
				srcPositions[idx] = CoreUtils.interpolate(interp, srcPositions[idx], targetPositions[idx]);
				srcPositions[idx + 1] = CoreUtils.interpolate(interp, srcPositions[idx + 1], targetPositions[idx + 1]);
				srcPositions[idx + 2] = CoreUtils.interpolate(interp, srcPositions[idx + 2], targetPositions[idx + 2]);
			}
		}, true);
		*/

		mesh2.dispose();

		return [mesh1];
	}
}